import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {AgencyUser} from "../../entities/AgencyUser.ts";

export class GetAgencyUsersUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string): Promise<AgencyUser[]> {
        return this.agencyRepository.getAgencyUsers(agencyId)
    }
}
